<template>
  <div class="lab-staff">
    <StaffContents
    :profileImg="require('../../assets/img/lab/staff/02/profile.png')"
    :profileImgSp="require('../../assets/img/lab/staff/02/profile_sp.png')"
    profileAlt="02 YINGGE XIAO"
    answer01="大学で航空機や人工衛星の材料をはじめ、ゴルフクラブなどのスポーツ・レジャー用途でも使用されるポリアクリロニトリル（PAN）系炭素繊維に関する研究を行いました。PANの重合から炭素繊維の黒鉛化まで一連の製造プロセスにおける構造解析および製造条件の最適化検討に取り組んでいました。高分子材料、炭素材料、繊維など多くの分野を横断し、複数の基礎技術を融合させて開発した製品だったため、幅広くいろいろ勉強をしました。"
    answer02="理由はいくつかあります。まず、クレハが技術立社として数多くのオリジナル製品を持ち、研究開発に注力しているところ。そして、グローバルに生産拠点やグループ会社を持つだけでなく、ビジネスを展開しているところ。私は海外で働くことに挑戦したかったので、この点に強く惹かれました。そして何より、面接の担当だった人事部長が、私に対する期待と入社後の具体的な展望について熱く語ってくれたこと。ほとんど日本語が話せなかった私に真剣に接してくれていると感じたことが、入社の決め手となりました。"
    answer03="研究所での新規海洋防汚塗料、新規生分解性樹脂の研究開発などを経て、現在はPVDF樹脂である「KFポリマー」の技術営業として東京の本社に勤務。国内企業への営業活動はもちろん、中国グループ会社の支援、中国顧客の相談窓口も担当しています。技術営業はクレハを代表して製品の説明をする立場なので、顧客の用途に応じた幅広い知識が必要不可欠です。技術系出身である強みを活かし、顧客の要求を汲み取ることを心がけて仕事に取り組んでいます。"
    answer04="個人的なスキルをもっと向上させ、将来的には海外駐在を目指しています。特に、中国市場の開拓は今後のクレハにとって大変重要になってくると思います。自分のバックボーンやこれまでの経験を活かし、大きな役割を担えるように成長していきたいです。また、先輩社員には子育てをしながら働いている方が多くいるので、私も自分に合った働き方でワークライフバランスを充実させていきたいですね。"
    answer05="とにかく働きやすい！東京の本社もいわきの事業所も、優しくて包容力がある人ばかりです。福利厚生も充実していて、仕事と家庭を両立している先輩がたくさんいます。それと、若手の意見にも耳を傾けてくれる風土があるので、自分の考えを堂々と発信できる人にはとても働きやすい環境だと思います。就職活動中は不安なことがたくさんあると思いますが、とにかく自分に自信を持っていろいろなことに挑んでください！"
    answer06="夫と同じジムに入会していて、週末のうち一回は一緒に通っています。普段のデスクワークでガチガチになりがちな体を動かすと、リフレッシュに加えて体力もつくので仕事のパフォーマンスも上がるんです。また、天気が良い日は外食をしたり、遊びに行ったりもします。あいにくの天気の日は、家で映画を見たり、新しい料理作りに挑戦しています。お家でゆったり過ごす週末も良い気分転換になりますね。"
    :imageCut01="require('../../assets/img/lab/staff/02/image01.jpg')"
    :imageCut02="require('../../assets/img/lab/staff/02/image02.jpg')"
    :imageCut01Sp="require('../../assets/img/lab/staff/02/image01_sp.jpg')"
    :imageCut02Sp="require('../../assets/img/lab/staff/02/image02_sp.jpg')"
    :schedule="require('../../assets/img/lab/staff/02/schedule.svg')"
    :scheduleSp="require('../../assets/img/lab/staff/02/schedule_sp.svg')"
    />
  </div>
</template>

<script>
import StaffContents from "@/components/lab/StaffContents.vue";
export default {
  name: 'staff_member',
  components: {
    StaffContents,
  },
  methods: {
    startIntersectionObserver: function(targets) {
      this.intersectionObserver = new IntersectionObserver(changes => {
        changes.forEach(change => {
          if(change.isIntersecting) {
            change.target.classList.add('is-show');
          }
        });
      },{
        rootMargin: "0px",
        // threshold: [1.0],
      });
      targets.forEach(target => {
        this.intersectionObserver.observe(target);
      });
    },
  },
  mounted() {
    const targets = Array.from(document.querySelectorAll('.faq'));
    this.startIntersectionObserver(targets);
  }
}
</script>
